import type { SupabaseClient } from "@supabase/supabase-js";

export type WebEngagementEventType =
  | "restaurant_view"
  | "qr_scan"
  | "directions_tap"
  | "instagram_tap"
  | "website_tap";

/**
 * Best-effort insert into restaurant_engagement_events (owner Insights).
 * Never throws — analytics must not break the public page.
 */
export async function logRestaurantEngagement(
  supabase: SupabaseClient,
  args: {
    restaurantId: string;
    eventType: WebEngagementEventType;
    menuId?: string | null;
    metadata?: Record<string, unknown>;
  }
): Promise<void> {
  try {
    if (!args.restaurantId) return;
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const { error } = await supabase.from("restaurant_engagement_events").insert({
      restaurant_id: args.restaurantId,
      menu_id: args.menuId ?? null,
      event_type: args.eventType,
      user_id: session?.user?.id ?? null,
      metadata: args.metadata ?? {},
    });
    if (error && process.env.NODE_ENV !== "production") {
      console.warn("[Engagement] web log failed", error.message, args.eventType);
    }
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[Engagement] web log unexpected", err);
    }
  }
}
